import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';

import { PAGE_THREATS } from '../../../config/pages';
import Text from '../../helpers/Text';

const setCharAt = (str, index, chr) => {
    if (index > str.length - 1) {
        return str;
    }
    return str.substr(0, index) + chr + str.substr(index + 1);
};

const shuffleString = (string) => {
    const a = string.split('');
    const n = a.length;

    for (let i = n - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join('');
};

class ThreatsOne extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            parallaxBottom: 0,
            tags: cloneDeep(props.t('threats.one.image.tags'))
        };
        this.scroll = this.scroll.bind(this);
        this.glitch = this.glitch.bind(this);
        this.glitchTag = this.glitchTag.bind(this);
        this.glitchReset = this.glitchReset.bind(this);

        this.glitchTagActive = false;
        this.glitchTimeout = null;
        this.componentIsMounted = false;
    }

    componentDidMount() {
        this.componentIsMounted = true;
        window.addEventListener('resize', this.scroll);
        window.addEventListener('scroll', this.scroll);

        this.glitch();
    }

    componentDidUpdate(nextProps) {
        if (this.props.language !== nextProps.language) {
            this.glitchReset();
        }
    }

    componentWillUnmount() {
        this.componentIsMounted = false;
        window.removeEventListener('resize', this.scroll);
        window.removeEventListener('scroll', this.scroll);
    }

    glitchReset() {
        clearTimeout(this.glitchTimeout);
        this.glitchTagActive = false;

        this.setState({ tags: cloneDeep(this.props.t('threats.one.image.tags')) });
        setTimeout(() => {
            this.glitch();
        }, 1000);
    }

    glitchTag(tagIndex, index, symbols, i) {
        setTimeout(() => {
            if (!this.glitchTagActive) {
                return;
            }

            const { tags } = this.state;
            tags[tagIndex] = setCharAt(tags[tagIndex], index, symbols.charAt(i));

            if (this.componentIsMounted) {
                this.setState({
                    tags
                });
            }

            const j = i + 1;
            if (j < symbols.length) {
                this.glitchTag(tagIndex, index, symbols, j);
            }
        }, 75);
    }

    glitch() {
        const tags = this.props.t('threats.one.image.tags');

        this.glitchTagActive = true;

        const symbols = '!@#$%^&*()';

        const tagsCount = tags.length;
        const tagIndex = Math.floor(Math.random() * tagsCount);

        const random = Math.floor(Math.random() * 5);
        const indexes = [];
        let textIndex;
        for (let x = 0; x < random; x += 1) {
            do {
                textIndex = Math.floor(Math.random() * tags[tagIndex].length);
            } while (indexes.indexOf(textIndex) !== -1);
            indexes.push(textIndex);

            const localSymbols = shuffleString(symbols) + tags[tagIndex].charAt(textIndex);
            this.glitchTag(tagIndex, textIndex, localSymbols, 0);
        }

        clearTimeout(this.glitchTimeout);
        this.glitchTimeout = setTimeout(this.glitch, 300);
    }

    scroll() {
        if (this.props.page === PAGE_THREATS && $('.container-threats-1').length > 0) {
            const winTop = $(window).scrollTop();
            const winHeight = $(window).height();

            const elemTop = $('.container-threats-1').offset().top;
            const elemHeight = $('.container-threats-1').outerHeight(true);

            const bgHeight = $('.threats-1-bg').outerHeight(true);
            const diff = bgHeight - elemHeight;

            if (diff > 0) {
                const parallaxStart = ((elemTop - winHeight) > 0) ? (elemTop - winHeight) : 0;
                const parallaxEnd = elemTop + elemHeight;
                const parallaxDiff = parallaxEnd - parallaxStart;

                if (winTop > parallaxStart && winTop < parallaxEnd) {
                    const percent = (winTop - parallaxStart) / parallaxDiff;
                    const parallaxBottom = (-1) * diff * percent;
                    this.setState({ parallaxBottom });
                } else {
                    this.setState({ parallaxBottom: 0 });
                }
            }

            if (this.state.show === false) {
                if (elemTop < (winTop + (winHeight / 2))) {
                    this.setState({ show: true });
                }
            }
        }
    }

    render() {
        const { parallaxBottom, tags } = this.state;
        const { t } = this.props;

        return (
            <div className="container-threats-1" id="container-threats-1">
                <div className="threats-1-bg" id="threats-1-bg" style={ { bottom: parallaxBottom } }>
                    <img src={ require('../../../assets/images/threats/1/bg@2x.jpg') } alt="Lemlock threats"/>
                </div>
                <div className="layout">
                    <div className="page-threats-1" id="page-threats-1">
                        <div className="section-title" id="section-title-1">
                            <h2 dangerouslySetInnerHTML={ { __html: t('threats.one.section.title') } }/>
                        </div>
                        <div className="threats-1-content" id="threats-1-content">
                            <div className="image" id="image-1">
                                <img className="icon" id="icon-1" src={ require('../../../assets/images/threats/1/image-2.svg') } alt="Lemlock threats"/>
                                <div className="text-top" id="text-top-1">{ t('threats.one.image.title') }</div>
                                {
                                    tags.map((tag, index) => (
                                        <div className={ cx('tag', `tag-${ (index + 1) }`) } data-text={ tag } key={ index }>{ tag }</div>
                                    ))
                                }
                            </div>
                            <div className="section-text-16" id="section-text-16-01">
                                <Text data={ t('threats.one.paragraphs') }/>
                            </div>
                        </div>
                        <div className="section-text-16 threats-1-note" id="threats-1-note">
                            <p>{ t('threats.one.note') }</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThreatsOne.propTypes = {
    t: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired
};

export default ThreatsOne;



// WEBPACK FOOTER //
// ./src/components/content/threats/ThreatsOne.jsx